export const FACTURE_FOURNISSEUR = {
    SET_FACTURES: 'SET_FACTURES',
    ADD_FACTURES: 'ADD_FACTURES',
    SET_FILTER_OPERATEUR: 'SET_FILTER_OPERATEUR',
    SET_FILTER_MONTANT: 'SET_FILTER_MONTANT',
    SET_FILTER_SOCIETE: 'SET_FILTER_SOCIETE',
    SET_FILTER_NUMERO_FACTURE: 'SET_FILTER_NUMERO_FACTURE',
    SET_FILTER_ETAT: 'SET_FILTER_ETAT',
    SET_FILTER_DATE_DEBUT: 'SET_FILTER_DATE_DEBUT',
    SET_FILTER_DATE_FIN: 'SET_FILTER_DATE_FIN',
    RESET_ITEMS: 'RESET_ITEMS',
    SET_FACTURES_LOADING: 'SET_FACTURES_LOADING',

    SET_SORT: 'SET_SORT',
    SET_SCROLL: 'SET_SCROLL',
    SET_NUMBER_OF_PAGES: 'SET_NUMBER_OF_PAGES',
    SET_PAGE: 'SET_PAGE',
    SET_NB_ELEMENTS: 'SET_NB_ELEMENTS',
    XLS_LOADING: 'XLS_LOADING'
};
